// extracted by mini-css-extract-plugin
export default {"root":"AdagioSwiper_root__TwEbX","counter":"AdagioSwiper_counter__aG+QB"};